import { createContext } from 'react';

export type VersionContextProps = {
  newVersionAvailable: boolean;
};

export const VersionContext = createContext<VersionContextProps>({
  newVersionAvailable: false,
});
